import React, { useEffect, useState, useContext } from 'react';
import { arrayOf, func, object } from 'prop-types';

import withData from 'util/hoc/with-data';
import { renderIfUser } from 'util/hoc/render-if-user';
import { resolve } from 'library/helpers/path-resolver';
import Query from 'library/util/query';
import UserProfileSetupModal from './components/user-profile-setup-modal';
import ReloadParentWrapper from 'structures/reload-parent-wrapper';
import withUserOutcomes from 'apps/journey/hoc/with-user-outcomes';
import ReloadRecommendationsContext from 'apps/journey/pages/my-journey2/context/reload-recommendations-context';

const UserProfileSetup = ({
  graph_data,
  graph_loading,
  reload_graph,
  reloadOutcomes,
  ...props
}) => {
  const [active, setActive] = useState(true);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [renderUserProfileSetup, setRenderUserProfileSetup] = useState(true);

  const { setReloadRecommendations } = useContext(ReloadRecommendationsContext);

  const questions = resolve(graph_data, 'questions', []);
  const question_groups = resolve(graph_data, 'question_groups', []);

  useEffect(() => {
    if (questions.length > 0) {
      setRenderUserProfileSetup(true);
      setIsFirstLoad(false);
    }
  }, [questions]);

  const handleOnClose = () => {
    reloadOutcomes(true);
    setReloadRecommendations();
    setActive(false);
  };

  return !isFirstLoad && renderUserProfileSetup ? (
    <ReloadParentWrapper reload_graph={reload_graph}>
      <UserProfileSetupModal
        active={active}
        onClose={handleOnClose}
        questions={questions}
        question_groups={question_groups}
        graph_loading={graph_loading}
      />
    </ReloadParentWrapper>
  ) : null;
};

UserProfileSetup.propTypes = {
  questions: arrayOf(object),
  question_groups: arrayOf(object),
  reload_graph: func,
};

UserProfileSetup.defaultProps = {
  questions: [],
  question_groups: [],
};

UserProfileSetup.query = async () =>
  await Query(`
    query {
      questions (question_set: "user_profile_setup", include_answered: false) {
        id
        text
        render_type
        required
        tooltip
        question_group_id
        order
        answer_choices {
          id
          key
          value
          metadata
        }
      }
      question_groups (question_set: "user_profile_setup", include_answered: false) {
        name
        order
        id
    	}
    }
  `);

UserProfileSetup.parseQueryData = (data) => ({
  questions: resolve(data, 'questions', []),
  question_groups: resolve(data, 'question_groups', []),
});

export default renderIfUser(withUserOutcomes(withData(UserProfileSetup)));
